export const ADMIN_USERS = [
    2,
    52203, // Franco
    53688, // Pedro
    53689, // Miguel
    53690, // Banestes
    151929, // Stheferson
    53694, // Luiz
    53695, // Brittes
    53696, // Alan
    53697, // Felipe
    53698, // David
    64908, // André
    66162, // Leo
    53755, // Nicolas
    53952, // Erick
    60750, // Nicolas de novo?
    129522, // Levi
    130710, // Diogo
    119754, // João Lucas
    146222, // Vinicius Buteri
    160877, // Julyan
];

export const BANK_MANAGEMENT_USERS = [
    2,
    53688, // Pedro
    53689, // Miguel
    66162, // Leo
    119754, // João Lucas
    146222, // Vinicius Buteri
    202023, // jonas
    206445, // gabriela fabian
]

export const CAN_USE_NEW_OPERATION = [
    146222, // Vinicius Buteri,
    53698, // David
    53688, // Pedro
    202023, // Jonas
    119754, // João Lucas
    160877, // Julyan
    53952, // Erick
    304851, // Giovanni
    151929, // Stheferson
    129522, // Levi
    ]